import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { ProfilePicture } from 'inside-out/components/support-organisations/profilePicture';
import LocationIcon from 'inside-out/images/location-icon-small.svg';
import {
	wrapperStyle,
	metaAudiencesStyle,
	locationStyle,
	wrapperLinkStyle,
	titleStyle,
	subTitleStyle,
	bodyStyle,
	photoStyle,
	attributeStyle,
} from './styles';

import { blue } from 'inside-out/global-styles';

class TreatmentServiceCardComponent extends React.PureComponent {
	render() {
		const { to, location, image, attributes, title, subTitle } = this.props;

		return (
			<Link className={wrapperLinkStyle} to={to} data-component="Card">
				<article className={wrapperStyle}>
					{ image && (
						<div className={photoStyle}>
							<ProfilePicture image={image} size={90} />
						</div>
					) }

					<div className={bodyStyle}>
						<h1 className={titleStyle}>{title}</h1>
						<p className={subTitleStyle}>{subTitle}</p>

						<div className={metaAudiencesStyle}>
							{attributes.map((attribute, i) => (
								<div key={i} className={attributeStyle(blue)}>
									<span>{attribute.title}</span>
								</div>
							))}
						</div>

						<div className={locationStyle}>
							<span>
								<img src={LocationIcon} alt="" /> {location}
							</span>
						</div>
					</div>
				</article>
			</Link>
		);
	}
}

TreatmentServiceCardComponent.propTypes = {
	to: PropTypes.string,
	location: PropTypes.string,
	attributes: PropTypes.array,
	title: PropTypes.string,
	subTitle: PropTypes.string,
	image: PropTypes.string,
};

export const TreatmentServiceCard = TreatmentServiceCardComponent;



// WEBPACK FOOTER //
// ./src/components/shared/cards/treatmentServiceCard/component.js